import React, { useEffect } from "react";
import { ITemplate } from "../../../../interfaces/ITemplate";
import { Card, CardContent, CircularProgress, Grid, Typography } from "@mui/material";
import { ContractAnswerRow } from "./ContractAnswerRow";
import { IContractDocumentAnswer } from "../../../../interfaces/IContractDocumentAnswer";
import { useGetTemplateById } from "../../../../hooks/data/data_templates";

interface IProps {
    id: number;
    template: ITemplate;
    answerArray: IContractDocumentAnswer[];
    setAnswerArray: Function;
}

export const ContractDocumentAnswer: React.FC<IProps> = ({ id, template, answerArray, setAnswerArray }) => {
    useEffect(() => {
        let tmpOfferAnswerArray: IContractDocumentAnswer[] = [];

        if (template && template.TemplateQuestions) {
            template.TemplateQuestions.map((question, idx) => {
                if (question.TemplateAnswers.length > 0) {
                    tmpOfferAnswerArray.push({
                        id: idx * -1 - 1,
                        TemplateAnswers: question.TemplateAnswers[0].id,
                        TemplateQuestions: question.id,
                        ContractDocument: id,
                    } as IContractDocumentAnswer);
                }
            });
        }
        setAnswerArray(tmpOfferAnswerArray);
    }, []);

    return (
        <>
            {template.TemplateQuestions.length > 0 && (
                <Card variant="outlined">
                    <CardContent>
                        <Typography variant="h6">{template.title}</Typography>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            {answerArray.map((x) => (
                                <ContractAnswerRow
                                    key={`question-row-${x.id}`}
                                    answerObject={x}
                                    template={template}
                                    answerArray={answerArray}
                                    setAnswerArray={setAnswerArray}
                                />
                            ))}
                        </Grid>
                    </CardContent>
                </Card>
            )}
        </>
    );
};
